//
import RemoveCircle from "src/components/ui/svgIcon/RemoveCircle";

// ----------------------------------------------------------------------

export default function Chip(theme) {
  return {
    MuiChip: {
      defaultProps: {
        deleteIcon: <RemoveCircle fontSize="small" mr={2} color={theme.palette.primary.contrastText} />,
      },
      styleOverrides: {
        filled: {
          borderRadius: "8px !important",
          backgroundColor: `${theme.palette.primary.main} !important`,
          color: `${theme.palette.primary.contrastText} !important`,
          fontSize: `14px !important`,
        },
        root: {
          colorDefault: {
            "& .MuiChip-avatarMedium, .MuiChip-avatarSmall": {
              color: theme.palette.text.secondary,
            },
          },
          outlined: {
            borderRadius: "8px !important",
            borderColor: theme.palette.grey.g5,
            "&.MuiChip-colorPrimary": {
              borderColor: theme.palette.primary.main,
            },
            "&.MuiChip-colorSecondary": {
              borderColor: theme.palette.secondary.main,
            },
          },
        },
        //
        avatarColorInfo: {
          color: theme.palette.info.contrastText,
          backgroundColor: theme.palette.info.dark,
        },
        avatarColorSuccess: {
          color: theme.palette.success.contrastText,
          backgroundColor: theme.palette.success.dark,
        },
        avatarColorWarning: {
          color: theme.palette.warning.contrastText,
          backgroundColor: theme.palette.warning.dark,
        },
        avatarColorError: {
          color: theme.palette.error.contrastText,
          backgroundColor: theme.palette.error.dark,
        },
      },
    },
  };
}
